<template>
  <div>
    <mdb-container class="mt-5 content-area mt-5">
      <PageHeader text="Profile"></PageHeader>

      <div class="d-flex justify-content-center mt-2" v-if="isLoading">
        <div class="spinner-grow text-primary" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
      <div class="mt-5" v-if="!isLoading">
        <!--Table-->
        <table id="tablePreview" class="table">
          <!--Table head-->
          <thead>
            <!--Table body-->
          </thead>
          <tbody>
            <tr>
              <th scope="row">First name</th>
              <td>{{ user.firstName }}</td>
            </tr>
            <tr>
              <th scope="row">Last name</th>
              <td>{{ user.lastName }}</td>
            </tr>
            <tr>
              <th scope="row">Mail</th>
              <td>{{ user.email }}</td>
            </tr>
            <tr>
              <th scope="row">Tokens</th>
              <td>
                {{ user.tokens }}
                <a href="/buy-tokens">
                  <span class="small">(buy more)</span>
                </a>
              </td>
            </tr>
            <tr>
              <th scope="row">Last login</th>
              <td>{{ new Date(user.lastLogin).toDateString() }}</td>
            </tr>
            <tr>
              <th scope="row">Password</th>
              <td>
                *********
                <a class="small" @click="modal = true">(change)</a>
              </td>
            </tr>
          </tbody>
          <!--Table body-->
        </table>
        <!--Table-->

        <mdb-modal size="md" :show="modal" @close="closeModal">
          <mdb-modal-header>
            <mdb-modal-title>Change password</mdb-modal-title>
          </mdb-modal-header>
          <mdb-modal-body>
            <div class="d-flex justify-content-center mt-5" v-if="localLoading">
              <div class="spinner-grow text-primary" role="status">
                <span class="sr-only">Loading...</span>
              </div>
            </div>
            <form v-if="!localLoading">
              <div v-if="showAlert" class="col-12">
                <mdb-alert class="d-flex justify-content-center" color="danger">
                  <b>Oh no,</b>
                  {{ alertText }}
                </mdb-alert>
              </div>
              <div class="grey-text">
                <mdb-input
                  label="Your old password"
                  icon="lock"
                  type="password"
                  v-model="oldPassword"
                />
                <mdb-input
                  label="Your new password"
                  icon="lock"
                  type="password"
                  v-model="newPassword"
                />
                <mdb-input
                  label="Repeat your new password"
                  icon="lock"
                  type="password"
                  v-model="newPasswordRe"
                />
              </div>
            </form>
          </mdb-modal-body>
          <mdb-modal-footer>
            <mdb-btn color="primary" size="sm" @click.native="changePassword"
              >Save</mdb-btn
            >
            <mdb-btn color="secondary" size="sm" @click.native="closeModal"
              >Close</mdb-btn
            >
          </mdb-modal-footer>
        </mdb-modal>
      </div>
    </mdb-container>
  </div>
</template>

<script>
import {
  mdbContainer,
  mdbModal,
  mdbModalHeader,
  mdbModalTitle,
  mdbModalBody,
  mdbModalFooter,
  mdbBtn,
  mdbInput,
  mdbAlert,
} from "mdbvue";
import PageHeader from "../../components/PageHeader";
export default {
  name: "BuyTokens",
  components: {
    mdbContainer,
    PageHeader,
    mdbModal,
    mdbModalHeader,
    mdbModalTitle,
    mdbModalBody,
    mdbModalFooter,
    mdbBtn,
    mdbInput,
    mdbAlert,
  },
  computed: {
    isLoading: function() {
      return this.$store.getters["ui/isLoading"];
    },
    user: function() {
      return this.$store.getters["user/user"];
    },
  },
  methods: {
    changePassword: function() {
      this.localLoading = true;

      if (this.newPassword !== this.newPasswordRe) {
        this.localLoading = false;
        this.alertText = " please check your passwords";
        this.showAlert = true;
        this.oldPassword = "";
        this.newPassword = "";
        this.newPasswordRe = "";
        return;
      }

      const payload = {
        oldPassword: this.oldPassword,
        newPassword: this.newPassword,
      };

      this.$store
        .dispatch("user/changePassword", payload)
        .then(() => {
          this.closeModal();

          this.$toasted.show("Your password has been changed.", {
            theme: "bubble",
            position: "top-center",
            duration: 2000,
          });
        })
        .catch(() => {
          this.alertText = " please check your old password";
          this.showAlert = true;
          this.oldPassword = "";
          this.newPassword = "";
          this.newPasswordRe = "";
          this.localLoading = false;
        });
    },
    closeModal: function() {
      this.modal = false;
      this.showAlert = false;
      this.alertText = "";
      this.newPassword = "";
      this.newPasswordRe = "";
      this.localLoading = false;
    },
    resetModal: function() {},
  },
  data() {
    return {
      showAlert: false,
      alertText: "",
      modal: false,
      oldPassword: "",
      newPassword: "",
      newPasswordRe: "",
      localLoading: false,
    };
  },
  created: function() {},
  mounted: function() {},
};
</script>
